var styles = {"body":"MainWrapper_body_1yh6g_1","header":"MainWrapper_header_1yh6g_6","with-prev":"MainWrapper_with-prev_1yh6g_23","close":"MainWrapper_close_1yh6g_26","prev":"MainWrapper_prev_1yh6g_97"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
